/**
 * Default environment file (development).
 *
 * Build-time `fileReplacements` in `apps/platform/project.json` swap this file
 * with `environment.qa.ts`, `environment.staging.ts`, or `environment.prod.ts`
 * for the matching `nx build/serve --configuration=<env>`.
 *
 * Schema mirrors `fb-shipper-frontend/src/environments/env.config.dev.json`.
 *
 * NOTE on `apiUrl`:
 *   For local serve we keep `apiUrl` empty so HTTP calls become relative
 *   (`/oauth/token`, `/api/...`) and are forwarded by `proxy.conf.json` to
 *   `https://dev-api.freightify.io`. This sidesteps browser CORS without
 *   needing the backend to allowlist `http://localhost:4200`.
 *
 *   `proxy.conf.json` is the source of truth for the upstream dev backend.
 */
import { Environment } from './environment.types';

export const environment: Environment = {
  production: false,
  name: 'development',
  apiUrl: 'https://dev-api.freightify.io',
  clientId: '2',
  clientSecret: 'SyMQ2QaohjBbgfpTZPQiy6EdqonlmIAx1ZEqCPt7',
  localHostName: 'fwda.devship.freightify.io',
};
